var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIssuesoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "69.000000pt",
    height: "61.000000pt",
    viewBox: "0 0 69.000000 61.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,61.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248 530 c-10 -16 -24 -20 -64 -20 -32 0 -56 -5 -63 -14 -8 -9 -11 -81 -9 -237 l3 -224 205 0 205 0 3 138 c2 93 -1 136 -8 132 -6 -4 -10 -56 -10 -131 l0 -124 -190 0 -190 0 2 217 3 218 38 3 c36 3 37 3 37 -32 l0 -36 110 0 110 0 0 36 c0 35 1 35 37 32 30 -2 38 -8 44 -28 6 -23 7 -23 14 -6 14 33 -7 51 -66 54 -39 2 -57 8 -67 23 -20 28 -126 28 -144 -1z m129 -20 c3 -11 9 -20 14 -20 5 0 9 -11 9 -25 0 -25 -1 -25 -80 -25 -66 0 -82 3 -87 16 -4 10 0 22 8 28 9 6 18 19 22 29 5 13 18 17 58 17 42 0 52 -3 56 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 511 c-21 -14 -5 -43 21 -39 15 2 23 10 23 23 0 22 -22 30 -44 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 358 c-75 -71 -126 -127 -137 -153 -10 -22 -19 -34 -19 -27 0 14 -130 18 -130 3 0 -15 141 -18 183 -4 25 8 79 51 158 125 65 61 119 115 119 120 0 8 -41 48 -49 48 -3 0 -60 -51 -125 -112z m139 71 c10 -15 -1 -23 -20 -15 -9 3 -13 10 -10 16 8 13 22 13 30 -1z m-113 -121 c-67 -68 -84 -80 -94 -69 -11 10 3 27 72 92 56 51 88 75 95 68 6 -6 -19 -38 -73 -91z m-112 -99 c0 -5 -7 -9 -15 -9 -9 0 -12 6 -9 15 6 15 24 11 24 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 344 c-17 -17 13 -24 108 -24 104 0 135 5 135 21 0 10 -233 13 -243 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 260 c0 -6 33 -10 80 -10 47 0 80 4 80 10 0 6 -33 10 -80 10 -47 0 -80 -4 -80 -10z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuesoss);
export default __webpack_public_path__ + "static/media/issuesoss.85e7c35e5c5582f2b243571efd145e36.svg";
export { ForwardRef as ReactComponent };